export default "__VITE_ASSET__BNaJPFRc__"